// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"47a30484","197":"7b5b57ea","212":"af2f473f","396":"07423149","421":"25b1d5ea","655":"1916de01"}[chunkId] + ".chunk.css";
};